// src/pages/SearchResults.jsx
import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Search } from 'lucide-react';
import { searchRoutes } from '../utils/searchRoutes';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { useTheme } from '../contexts/ThemeContext';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const SearchResults = () => {
  const { darkMode, toggleDarkMode } = useTheme();
  const q = useQuery().get('q')?.trim().toLowerCase() || '';
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (q) {
      setResults(
        searchRoutes.filter(route =>
          route.name.toLowerCase().includes(q) ||
          (route.description && route.description.toLowerCase().includes(q)) ||
          route.path.toLowerCase().includes(q)
        )
      );
    } else {
      setResults([]);
    }
  }, [q]);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-200">
      {/* Фоновый узор */}
      <div className="fixed inset-0 bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] dark:bg-[radial-gradient(#1f2937_1px,transparent_1px)] [background-size:20px_20px] opacity-25 pointer-events-none"></div>
      <Header darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="text-2xl font-bold mb-4 flex items-center">
          <Search className="h-6 w-6 mr-2 text-gray-500" />
          Результаты поиска: «{q}»
        </h1>

        {results.length > 0 ? (
          <ul className="space-y-4">
            {results.map(route => (
              <li key={route.path} className="border rounded-lg p-4 hover:shadow-md transition-shadow">
                <Link to={route.path} className="text-xl font-medium text-indigo-600 hover:underline">
                  {route.name}
                </Link>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-gray-700 dark:text-gray-300">
            {q ? `По запросу «${q}» ничего не найдено.` : 'Введите запрос для поиска.'}
          </p>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default SearchResults;